/* eslint-disable react-hooks/exhaustive-deps */
import { ComponentProps, useEffect, useState, memo } from 'react'
import { Alert } from 'react-bootstrap'

const DEFAULT_DISMISSABLE_TIMEOUT = 3000
interface IProps extends ComponentProps<typeof Alert> {
  message: string
  variant?: 'danger' | 'success'
  autoDismissable?: boolean | number
  onClose?: () => void
}
export const DismissableAlert = memo(({ message, variant = 'danger', onClose, autoDismissable, ...props }: IProps) => {
  const [show, setShow] = useState(!!message)

  useEffect(() => {
    setShow(Boolean(message))
  }, [message])

  useEffect(() => {
    let timeoutHandler
    if (autoDismissable && show) {
      const timeout = typeof autoDismissable === 'number' ? autoDismissable : DEFAULT_DISMISSABLE_TIMEOUT

      timeoutHandler = setTimeout(() => {
        setShow(false)
        onClose?.()
      }, timeout)
    }

    return () => {
      if (timeoutHandler) {
        clearTimeout(timeoutHandler)
      }
    }
  }, [autoDismissable, show])

  return (
    show && (
      <Alert
        data-testid="dismisableAlert"
        variant={variant}
        onClose={() => {
          setShow(false)
          onClose?.()
        }}
        dismissible
        {...props}
      >
        <span dangerouslySetInnerHTML={{ __html: message }}></span>
      </Alert>
    )
  )
})
